// src/services/AuthService.ts
export const isAuthenticated = (): boolean => {
  console.log();
  const token = localStorage.getItem("token");
  return !!token; // true se houver token, false se não
};

export const logout = () => {
  localStorage.removeItem("token");
};
